export var WEEKLY_SCHEDULE_CONTAINER = 'weeklyScheduleContainer';
export var WEEKLY_SCHEDULE_HEADER = 'weeklyScheduleHeader';
export var WEEKLY_SCHEDULE_FOOTER = 'weeklyScheduleFooter';
export var WEEKLY_SCHEDULE_EVENT_LEGEND = 'weeklyScheduleEventLegend';
export var WEEKLY_SCHEDULE_GRID_CONTAINER = 'weeklyScheduleGridContainer';
export var WEEKLY_SCHEDULE_HOUR_GRID = 'weeklyScheduleHourGrid';
export var WEEKLY_SCHEDULE_EVENT_BLOCK_GRID = 'weeklyScheduleEventBlockGrid';
export var getEventBlockWrapperTestId = function (eventId) {
    return "eventBlockWrapper-".concat(eventId);
};
export var getEventBlockTestId = function (eventId) { return "eventBlock-".concat(eventId); };
export var getEventBlockIconTestId = function (eventId) {
    return "".concat(getEventBlockTestId(eventId), "-icon");
};
export var getHourHorizontalLineTestId = function (hour) { return "hourLine".concat(hour); };
export var getHourLabelTestId = function (hour) { return "hourLabel-".concat(hour); };
// eslint-disable-next-line no-restricted-globals
export var getDateId = function (date) {
    return "date-".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
};
export var WEEK_ROW = 'weekRow';
export var WEEK_ROW_HEADER = 'weekRowHeader';
export var WEEK_ROW_DATEPICKER = 'weekRowDatepicker';
export var ATOZ_DATEPICKER = 'AtoZDatepicker';
export var WEEK_ROW_NAV_PREV = 'weekRowNavPrev';
export var WEEK_ROW_NAV_NEXT = 'weekRowNavNext';
export var WEEK_ROW_TITLE = 'weekRowTitle';
